import React from 'react'
import PropTypes from 'prop-types'

import styles from './DiscountTag2022.scss'

import Price from '../Price'

const DiscountTag2022 = (props) => {
	const lang = SHVO.pageLang ?? '';
	const {value, currency, top, bottom, left, right, rotate, imageVariant, addPercent} = props

	if (value === 0) {
		return null
	}

	const style = {}
	if (top != 0) {
		style['top'] = `${top}px`
	}
	if (right != 0) {
		style['right'] = `${right}px`
	}
	if (bottom != 0) {
		style['bottom'] = `${bottom}px`
	}
	if (left != 0) {
		style['left'] = `${left}px`
	}
	if (rotate != 0) {
		style['transform'] = `rotate(${rotate}deg)`
	}

	const classNames = [styles.container]
	classNames.push(styles['image-' + imageVariant])
	classNames.push(styles[`image-${imageVariant}${lang !== '' ? '-' + lang : ''}`])
	classNames.push(styles[currency])

	return (
	  <div className={classNames.join(' ')} style={style}>
		  <Price
			currencyClass={styles.currency}
			valueClass={styles.price}
			value={-1 * parseInt(value)}
			currency={currency}
			addPercent={addPercent}
			removeDoubleZeros={true}
		  />
	  </div>
	)
}

DiscountTag2022.defaultProps = {
	top: 0,
	left: 0,
	right: 0,
	bottom: 0,
	rotate: 0,
	imageVariant: 'b',
	addPercent: false,
}
DiscountTag2022.propTypes = {
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	currency: PropTypes.string,
	addPercent: PropTypes.bool,
	top: PropTypes.number,
	left: PropTypes.number,
	right: PropTypes.number,
	bottom: PropTypes.number,
	rotate: PropTypes.number,
	imageVariant: PropTypes.oneOf(['a', 'b', 'percent', 'percent-new', 'percent-new-offer', 'percent-new-offer-en', 'a-en', 'b-en', 'percent-en', 'percent-new-en']),
}

export default DiscountTag2022